module.exports = __webpack_public_path__ + "img/ring_g_c_0_0.8f215c7f.png";